import React from 'react';
import { PlanningMetrics } from '../types';

interface PlanningMetricsProps {
    metrics: PlanningMetrics;
}

export const PlanningMetricsComponent: React.FC<PlanningMetricsProps> = ({ metrics }) => {
    const metricItems = [
        {
            label: 'Total employés',
            value: metrics.totalEmployees,
            color: 'text-blue-600',
            bgColor: 'bg-blue-50'
        },
        {
            label: 'Présents aujourd\'hui',
            value: metrics.presentToday,
            color: 'text-green-600',
            bgColor: 'bg-green-50'
        },
        {
            label: 'Absents aujourd\'hui',
            value: metrics.absentToday,
            color: 'text-red-600',
            bgColor: 'bg-red-50'
        },
        {
            label: 'En congé aujourd\'hui',
            value: metrics.onVacationToday,
            color: 'text-blue-600',
            bgColor: 'bg-blue-50'
        },
        {
            label: 'Taux de présence hebdomadaire',
            value: `${metrics.weeklyPresenceRate}%`,
            color: 'text-green-600',
            bgColor: 'bg-green-50'
        },
        {
            label: 'Taux de présence mensuel',
            value: `${metrics.monthlyPresenceRate}%`,
            color: 'text-green-600',
            bgColor: 'bg-green-50'
        },
        {
            label: 'Total heures/semaine',
            value: `${metrics.totalWeeklyHours}h`,
            color: 'text-purple-600',
            bgColor: 'bg-purple-50'
        },
        {
            label: 'Moyenne par employé',
            value: `${metrics.averageHoursPerEmployee}h`,
            color: 'text-purple-600',
            bgColor: 'bg-purple-50'
        }
    ];

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Métriques du planning</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
                {metricItems.map((item, index) => (
                    <div
                        key={index}
                        className={`${item.bgColor} rounded-lg p-4 text-center border`}
                    >
                        <div className={`text-2xl font-bold ${item.color} mb-1`}>
                            {item.value}
                        </div>
                        <div className="text-sm text-gray-600 leading-tight">
                            {item.label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};